import { render, staticRenderFns } from "./SingleSwitch.vue?vue&type=template&id=b4f1c0d4"
import script from "./SingleSwitch.vue?vue&type=script&lang=js"
export * from "./SingleSwitch.vue?vue&type=script&lang=js"
import style0 from "./SingleSwitch.vue?vue&type=style&index=0&id=b4f1c0d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports